import React from "react";
import styled from "styled-components";
import boIkon10 from "../../../assets/images/HeyBO_Logo.png";
import LayoutContext from "./../../../contexts/LayoutContext";
import { Link } from "react-router-dom";
/* #region CSS */
const StyledPage = styled.div`
    &.frame-1000011129,
    &.frame-1000011129 * {
        box-sizing: border-box;
    }
    &.frame-1000011129 {
        display: flex;
        flex-direction: column;
        gap: 25px;
        align-items: center;
        justify-content: center;
        position: relative;

        width: 100%;
        height: 80px;
    }
    .line-1 {
        margin-top: -1px;
        border-style: solid;
        border-color: rgba(166, 166, 166, 0.2);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-313681 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        position: relative;
        width: 100%;
        padding: 0px 25px;
    }
    .b-otag-technology-b-v-all-rights-reserved-2025 {
        color: #ffffff;
        text-align: left;
        font-family: "NeuzeitGrotesk-Light", sans-serif;
        font-size: 12px;
        line-height: 27px;
        font-weight: 300;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-1000011128 {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .group-3684 {
        flex-shrink: 0;
        height: 31px;
        position: relative;
        overflow: visible;
    }
    .returns-terms-conditions-privacy-policy {
        color: #ffffff;
        text-align: right;
        font-family: "NeuzeitGrotesk-Light", sans-serif;
        font-size: 18px;
        line-height: 27px;
        font-weight: 300;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .returns-terms-conditions-privacy-policy-span {
        color: #ffffff;
        font-family: "NeuzeitGrotesk-Light", sans-serif;
        font-size: 12px;
        line-height: 27px;
        font-weight: 300;
        text-decoration: underline;
    }
    .returns-terms-conditions-privacy-policy-span2 {
        color: #ffffff;
        font-family: "NeuzeitGrotesk-Light", sans-serif;
        font-size: 12px;
        line-height: 27px;
        font-weight: 300;
    }
    .returns-terms-conditions-privacy-policy-span3 {
        color: #ffffff;
        font-family: "NeuzeitGrotesk-Light", sans-serif;
        font-size: 12px;
        line-height: 27px;
        font-weight: 300;
        text-decoration: underline;
    }
    .returns-terms-conditions-privacy-policy-span4 {
        color: #ffffff;
        font-family: "NeuzeitGrotesk-Light", sans-serif;
        font-size: 12px;
        line-height: 27px;
        font-weight: 300;
    }
    .returns-terms-conditions-privacy-policy-span5 {
        color: #ffffff;
        font-family: "NeuzeitGrotesk-Light", sans-serif;
        font-size: 12px;
        line-height: 27px;
        font-weight: 300;
        text-decoration: underline;
    }
    .returns-terms-conditions-privacy-policy-span5:hover,
    .returns-terms-conditions-privacy-policy-span3:hover,
    .returns-terms-conditions-privacy-policy-span:hover {
        color: #f7665f;
        cursor: pointer;
    }
    @media only screen and (max-width: 768px) {
        &.frame-1000011129 {
            padding-top: 0px;
            padding-bottom: 0px;
            height: 147px;
        }
        .frame-313681 {
            flex-direction: column;
            gap: 10px;
            padding: 0px;
        }
        .b-otag-technology-b-v-all-rights-reserved-2025 {
            text-align: center;
            font-size: 14px;
            line-height: 24px;
        }
        .frame-1000011128 {
            width: 100%;
            order: -1;
            padding: 0px 0px;
        }
        .returns-terms-conditions-privacy-policy {
            text-align: center;
            font-size: 16px;
            line-height: 24px;
        }
        .line-1 {
            display: none;
        }
    }
`;
/* #endregion CSS */
export default function Footer() {
    const { setShowPolicyPopup } = React.useContext(LayoutContext);
    const currentYear = new Date().getFullYear();
    const gotoTop = () => {
        const element = document.querySelector(".main");
        if (element) {
            element.scrollTo({ top: 0, behavior: "smooth" });
        }
    };
    return (
        /*<StyledPage className="frame-295922556">
            <img className="exclusion-7" src={boIkon10} alt="home" />
            <div className="frame-295922535">
                <div className="_2025-b-otag-norge-as">© 2025 BOtag Norge AS</div>
                <div className="div">|</div>
                <div className="all-rights-reserved">All rights reserved</div>
                <div className="div">|</div>
                <div className="returns" onClick={() => setShowPolicyPopup("returns")}>
                    Returns
                </div>
                <div className="div">|</div>
                <div className="terms-conditions" onClick={() => setShowPolicyPopup("terms")}>
                    Terms &amp; Conditions
                </div>
                <div className="div">|</div>
                <div className="privacy-policy" onClick={() => setShowPolicyPopup("privacy")}>
                    Privacy Policy
                </div>
            </div>
        </StyledPage>*/
        <StyledPage className="frame-1000011129">
            <div className="frame-313681">
                <div className="b-otag-technology-b-v-all-rights-reserved-2025">
                    © BOtag Technology B.V. All rights reserved {currentYear}
                </div>
                <div className="frame-1000011128">
                    <Link to="/" onClick={gotoTop}>
                        <img className="group-3684" src={boIkon10} alt="home" />
                    </Link>
                </div>
                <div className="returns-terms-conditions-privacy-policy">
                    <span>
                        <span className="returns-terms-conditions-privacy-policy-span" onClick={() => setShowPolicyPopup("returns")}>
                            Returns
                        </span>{" "}
                        <span className="returns-terms-conditions-privacy-policy-span2">.</span>{" "}
                        <span className="returns-terms-conditions-privacy-policy-span3" onClick={() => setShowPolicyPopup("terms")}>
                            Terms &amp; Conditions
                        </span>{" "}
                        <span className="returns-terms-conditions-privacy-policy-span4">.</span>{" "}
                        <span className="returns-terms-conditions-privacy-policy-span5" onClick={() => setShowPolicyPopup("privacy")}>
                            Privacy Policy
                        </span>
                    </span>
                </div>
            </div>
        </StyledPage>
    );
}
